module.exports = __webpack_public_path__ + "static/media/Bacck.29e53cf5.png";